









import { Component, Prop, Vue } from "vue-property-decorator";
import { prepareMoney } from "@/assets/scripts/utils";
import { formatDate } from "@/lib/date";
import { OrganizationTurnoversDetails } from "@/models/organization";
import XDataTable from "../hoc/Table.vue";

@Component({
  components: { XDataTable },
})
class InvoiceTable extends Vue {
  @Prop({ default: () => [] }) readonly items!: OrganizationTurnoversDetails[];

  headers = [
    { text: "Тип документа", value: "docType" },
    { text: "Дата", value: "docDate" },
    { text: "Номер", value: "docNumber" },
    { text: "Сумма с НДС", value: "amountWithTax", align: "end" },
    { text: "Сумма без НДС", value: "amountWithoutTax", align: "end" },
    { text: "Вид деятельности", value: "activityType" },
    { text: "Объем", value: "volume", align: "end" },
  ];

  public get preparedItems() {
    const requiredKeys = [
      "тип",
      "дата",
      "номер",
      "суммасндс",
      "суммабезндс",
      "аналитика",
      "объем",
    ];

    return this.items.map((item) =>
      requiredKeys.map((key, i) => {
        const value = item[key];

        if (i === 1) return formatDate(value, "full");

        if ([3, 4, 6].includes(i)) return prepareMoney(value);

        return value;
      })
    );
  }
}

export default InvoiceTable;
